const languagesShortened = {
  AD: "ca_ES",
  AE: "ar_AE",
  AF: "fa_AF",
  AG: "en_US",
  AI: "en_US",
  AL: "sq_AL",
  AM: "hy_AM",
  AN: "nl_NL",
  AO: "pt_PT",
  AQ: "en_US",
  AR: "es_ES",
  AS: "en_US",
  AT: "de_DE",
  AU: "en_US",
  AW: "nl_NL",
  AZ: "az_AZ",

  BA: "bs_BA",
  BB: "en_US",
  BD: "bn_BD",
  BE: "nl_NL",
  BF: "fr_FR",
  BG: "bg_BG",
  BH: "ar_BH",
  BI: "fr_FR",
  BJ: "fr_FR",
  BM: "en_US",
  BN: "ms_MY",
  BO: "es_ES",
  BR: "pt_PT",
  BS: "en_US",
  BT: "dz_BT",
  BV: "en_US",
  BW: "en_US",
  BY: "be_BY",
  BZ: "en_US",

  CA: "en_US",
  CC: "en_US",
  CD: "fr_FR",
  CF: "fr_FR",
  CG: "fr_FR",
  CH: "de_DE",
  CI: "fr_FR",
  CK: "en_US",
  CL: "es_ES",
  CM: "fr_FR",
  CN: "zh_CN",
  CO: "es_ES",
  CR: "es_ES",
  CU: "es_ES",
  CV: "pt_PT",
  CX: "en_US",
  CY: "el_GR",
  CZ: "cs_CZ",

  DE: "de_DE",
  DJ: "fr_FR",
  DK: "da_DK",
  DM: "en_US",
  DO: "es_ES",
  DZ: "ar_DZ",

  EC: "es_ES",
  EE: "et_EE",
  EG: "ar_EG",
  EH: "ar_EH",
  ER: "ti_ER",
  ES: "es_ES",
  ET: "am_ET",
  FI: "fi_FI",
  FJ: "en_US",
  FK: "en_US",
  FM: "en_US",
  FO: "fo_FO",
  FR: "fr_FR",

  GA: "fr_FR",
  GB: "en_US",
  GD: "en_US",
  GE: "ka_GE",
  GF: "fr_FR",
  GG: "en_US",
  GH: "en_US",
  GI: "en_US",
  GL: "kl_GL",
  GM: "en_US",
  GN: "fr_FR",
  GP: "fr_FR",
  GQ: "es_ES",
  GR: "el_GR",

  GT: "es_ES",
  GU: "en_US",
  GW: "pt_PT",
  GY: "en_US",

  HK: "zh_HK",
  HM: "en_US",
  HN: "es_ES",
  HR: "hr_HR",
  HT: "fr_FR",
  HU: "hu_HU",

  ID: "id_ID",
  IE: "en_US",
  IL: "he_IL",
  IM: "en_US",
  IN: "hi_IN",
  IO: "en_US",
  IQ: "ar_IQ",
  IR: "fa_IR",
  IS: "is_IS",
  IT: "it_IT",

  JE: "en_US",
  JM: "en_US",
  JO: "ar_JO",
  JP: "ja_JP",

  KE: "en_US",
  KG: "ky_KG",
  KH: "km_KH",
  KI: "en_US",
  KM: "fr_FR",
  KN: "en_US",
  KP: "ko_KR",
  KR: "ko_KR",
  KW: "ar_KW",
  KY: "en_US",
  KZ: "kk_KZ",

  LA: "lo_LA",
  LB: "ar_LB",
  LC: "en_US",
  LI: "de_DE",
  LK: "si_LK",
  LR: "en_US",
  LS: "en_US",
  LT: "lt_LT",
  LU: "fr_FR",
  LV: "lv_LV",
  LY: "ar_LY",

  MA: "ar_MA",
  MC: "fr_FR",
  MD: "ro_RO",
  ME: "sr_RS",
  MG: "fr_FR",
  MH: "en_US",
  MK: "mk_MK",
  ML: "fr_FR",
  MM: "my_MM",
  MN: "mn_MN",
  MO: "zh_MO",
  MP: "en_US",
  MQ: "fr_FR",
  MR: "ar_MR",
  MS: "en_US",
  MT: "mt_MT",
  MU: "en_US",
  MV: "dv_MV",
  MW: "en_US",
  MX: "es_ES",
  MY: "ms_MY",
  MZ: "pt_PT",

  NA: "en_US",
  NC: "fr_FR",
  NE: "fr_FR",
  NF: "en_US",
  NG: "en_US",
  NI: "es_ES",
  NL: "nl_NL",
  NO: "nb_NO",
  NP: "ne_NP",
  NR: "en_US",
  NU: "en_US",
  NZ: "en_US",

  OM: "ar_OM",

  PA: "es_ES",
  PE: "es_ES",
  PF: "fr_FR",
  PG: "en_US",
  PH: "en_US",
  PK: "ur_PK",
  PL: "pl_PL",
  PM: "fr_FR",
  PN: "en_US",
  PR: "en_US",
  PS: "ar_PS",
  PT: "pt_PT",
  PW: "en_US",
  PY: "es_ES",

  QA: "ar_QA",

  RE: "fr_FR",
  RO: "ro_RO",
  RS: "sr_RS",
  RU: "ru_RU",
  RW: "rw_RW",

  SA: "ar_SA",
  SB: "en_US",
  SC: "fr_FR",
  SD: "ar_SD",
  SE: "sv_SE",
  SG: "en_US",
  SI: "sl_SI",
  SK: "sk_SK",
  SL: "en_US",
  SM: "it_IT",
  SN: "fr_FR",
  SO: "so_SO",
  SR: "nl_NL",
  SV: "es_ES",
  SY: "ar_SY",
  SZ: "en_US",

  TH: "th_TH",
  TJ: "tg_TJ",
  TL: "pt_PT",
  TM: "tk_TM",
  TN: "ar_TN",
  TO: "en_US",
  TR: "tr_TR",
  TT: "en_US",
  TV: "en_US",
  TW: "zh_TW",
  TZ: "en_US",

  UA: "uk_UA",
  UG: "en_US",
  US: "en_US",
  UY: "es_ES",
  UZ: "uz_UZ",

  VA: "it_IT",
  VC: "en_US",
  VE: "es_ES",
  VG: "en_US",
  VI: "en_US",
  VN: "vi_VN",
  VU: "en_US",

  WF: "fr_FR",
  WS: "en_US",

  XK: "sq_AL",

  YE: "ar_YE",
  YT: "fr_FR",

  ZA: "en_US",
  ZM: "en_US",
  ZW: "en_US",
};

export default languagesShortened;
